import { v4 as uuidv4 } from 'uuid';

const DEVICE_TOKEN_KEY = 'trusted_device_token';

export function getOrCreateDeviceToken(): string {
  let token = localStorage.getItem(DEVICE_TOKEN_KEY);
  if (!token) {
    token = uuidv4();
    localStorage.setItem(DEVICE_TOKEN_KEY, token);
  }
  return token;
}
